import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-employee-payrolls-detail',
  templateUrl: './employee-payrolls-detail.component.html',
  styleUrls: ['./employee-payrolls-detail.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,],
  providers: [DatePipe],
})
export class EmployeePayrollsDetailComponent implements OnInit {
  public user: any = [];
  public allSalaries: any = [];
  public selected_user_id: any = [];
  public selected_user_name: any = [];
  public selected_user_designation: any = [];
  public showSpinner = true;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  constructor(
    public activated_route: ActivatedRoute,
    public router: Router,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin" && user_role.role_type != "Admin_AND_Team_Lead") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.selected_user_id = this.activated_route.snapshot.paramMap.get('user_id')
    this.selected_user_name = this.activated_route.snapshot.paramMap.get('user_name')
    this.selected_user_designation = this.activated_route.snapshot.paramMap.get('designation')
    this.getAllSalries()
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

  addNewAttandance() {
  }

  getAllSalries() {
    this.dashboardService.getUserAllSalaries(this.selected_user_id).then((value) => {
      this.allSalaries = value.data;
      this.showSpinner = false;

    });

  }



  assignNewMmonthSalaryy() {
    const selected_date = (document.getElementById("salary_month") as HTMLInputElement).value;
    if (selected_date == null) {
      return
    }
    const date = new Date(selected_date);
    const month_char = this.datepipe.transform(date, "MMMM")
    const month_year = date.getFullYear()
    const month_int = date.getMonth() + 1
    const user_id = this.selected_user_id
    this.showSpinner = true;
    this.dashboardService.assignNewSalary(
      user_id,
      month_char,
      month_year,
      month_int).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'New Salary Assigned Successfully!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.showSpinner = true;
          this.getAllSalries()
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }

      });
  }

  getSaleryColor(status: string) {
    switch (status) {
      case "draft":
        return "#2a91da"
      case "approved":
        return "#52ecd7"
      case "released":
        return "#5bdc77"
      case "onhold":
        return "#e6ba3e"
    }
    return "#71D875"
  }

  showDetails(salary: any) {
    this.router.navigate(['/employee-payroll-salary-detail',
      {
        'user_id': this.selected_user_id,
        'mont_char': salary.month_char,
        'month_year': salary.month_year,
        'mont_int': salary.month_int,
        'salary_id': salary.id,
      }]);
  }
  isavailablefeature(type: string): boolean {
    switch (type) {
      case "isCreatePayroll":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.team_managment.data.values.create === false
      case "isViewPayroll":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.team_managment.data.values.view === false
      default:
        return false;

    }
    return false;
  }





}
